React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_bulk_actions_progress_done')
_ = require 'underscore'

module.exports = class extends React.Component
  render: t.renderable ->
    { results, modelLabel, modelName, onDoneClick, enterpriseDisplayName } = @props

    t.div ->
      t.h5 ->
        t.text " #{ modelLabel }: #{ modelName }"
      for status in _.keys(results) when results[status].length > 0
        t.div '.dash-bulk-add-results-heading', ->
          t.format ['status', status], { enterpriseDisplayName }
        t.div '.dash-bulk-add-results-list', ->
          for entry in results[status]
            t.div '.dash-bulk-add-results-list-item', ->
              t.text "#{ entry.member.fullName } (#{ entry.member.username })"

      t.div ->
        t.button
          class: 'primary full'
          onClick: onDoneClick
        , ->
          t.format 'done'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions/progress-component/done-component.coffee